<input
	type="text"
	class="form-control typeahead"
	[class.is-invalid]="searchFailed"
	[ngbTypeahead]="search"
	[formControl]="searchControl"
	[placeholder]="placeholder"
	(selectItem)="onSelect($event)"
	[resultFormatter]="formatter"
	[inputFormatter]="formatterInput"
	(focus)="onFocus()"
	(click)="onClick()"
	#ngbDistrict="ngbTypeahead"
/>
@if (searching) {
	<small class="form-text text-muted position-absolute">Recherche...</small>
}
